import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    TOGGLE_WORKER_LIST: 'TOGGLE_WORKER_LIST',
    TOGGLE_CONTEXT_MENU: 'TOGGLE_CONTEXT_MENU',
    PUSH_SNACKBAR: 'PUSH_SNACKBAR',
    CLEAR_MODAL_WORKER_DATA: 'CLEAR_MODAL_WORKER_DATA',
    SET_MODAL_WORKER_DATA: 'SET_MODAL_WORKER_DATA',
    SET_WORKER_LIST: 'SET_WORKER_LIST',
    SET_SELECTED_WORKER: 'SET_SELECTED_WORKER',
    ON_OFF_WORKER: 'ON_OFF_WORKER',
    UPDATE_WORKER: 'UPDATE_WORKER',
    ADD_WORKER: 'ADD_WORKER',
    CHECK_RELATED_WORKER: 'CHECK_RELATED_WORKER',
    DELETE_WORKER: 'DELETE_WORKER',
    DELETE_ALL_WORKER: 'DELETE_ALL_WORKER',
    DELAY_SHARE_ORDER: 'DELAY_SHARE_ORDER',
    ADD_ORDER: 'ADD_ORDER',
    SET_ORDER_LIST: 'SET_ORDER_LIST',
    ADD_SELECTED_ORDER_ITEM_BY_ID: 'ADD_SELECTED_ORDER_ITEM_BY_ID',
    CLEAR_SELECTED_ORDER_ITEM_BY_ID: 'CLEAR_SELECTED_ORDER_ITEM_BY_ID',
    SET_ORDER_FILTER: 'SET_ORDER_FILTER',
    SET_STATUS_TOTAL_COUNT: 'SET_STATUS_TOTAL_COUNT',
    UPDATE_STATUS_ORDER: 'UPDATE_STATUS_ORDER',
    UPDATE_ORDER_CARD_NAME: 'UPDATE_ORDER_CARD_NAME',
    UPDATE_ORDER: 'UPDATE_ORDER',
    DELETE_ORDER: 'DELETE_ORDER',
    SET_MODAL_ORDER_DATA: 'SET_MODAL_ORDER_DATA',
    SET_SELECT_FILTER: 'SET_SELECT_FILTER',
    CELAR_SELECTED_ORDER_ITEMS: 'CELAR_SELECTED_ORDER_ITEMS',
    SET_IS_STOP: 'SET_IS_STOP',
    SET_SORT_BY: 'SET_SORT_BY',
    /** 카드 주문 카운트 */
    SET_CARD_ORDER_COUNT: 'SET_CARD_ORDER_COUNT',
    /** 라이더 */
    ADD_RELATED_WORKER_LIST: 'ADD_RELATED_WORKER_LIST',
    CLEAR_RELATED_WORKER_LIST: 'CLEAR_RELATED_WORKER_LIST',
    SET_WORKER_FILTER: 'SET_WORKER_FILTER',
    UPDATE_STATUS_WORKER: 'UPDATE_STATUS_WORKER',
    INPUT_SEARCH_WORKER_QUERY: 'INPUT_SEARCH_WORKER_QUERY',
    SET_IS_HIDE_SHARE_WORKER: 'SET_IS_HIDE_SHARE_WORKER',
    SET_IS_HIDE_WORKER_MARKER: 'SET_IS_HIDE_WORKER_MARKER',
    SET_WORKER_TOTAL_COUNT: 'SET_WORKER_TOTAL_COUNT',
    SET_WORKER_SORT_BY: 'SET_WORKER_SORT_BY',
};
export const listControlMutationType = vuexEventPathGenerator(mutationType, 'listControl');
// 기본
const mutations = {
    [mutationType.TOGGLE_WORKER_LIST](state, payload) {
        state.toggleWorkerList = payload;
    },
    [mutationType.TOGGLE_CONTEXT_MENU](state, payload) {
        state.contextMenu = payload;
    },
    [mutationType.PUSH_SNACKBAR]() {
        // 이후 처리는 snackbar 모달에서 처리
        // Subscribe Mutation Only
    },
    [mutationType.CLEAR_MODAL_WORKER_DATA](state) {
        state.modalWorkerData = {};
    },
    [mutationType.SET_MODAL_WORKER_DATA](state, payload) {
        state.modalWorkerData = payload;
    },
    [mutationType.SET_WORKER_LIST](state, payload) {
        state.workerList = payload;
    },
    [mutationType.SET_SELECTED_WORKER](state, payload) {
        state.selectedWorker = payload;
    },
    [mutationType.ON_OFF_WORKER](state, { code, flag }) {
        if (!flag) {
            return state.workerList[code].isTemporallyOff = true;
        }
        return delete state.workerList[code].isTemporallyOff;
    },
    [mutationType.UPDATE_WORKER](state, worker) {
        const { user: { code } } = worker;
        state.workerList[code] = worker;
    },
    [mutationType.ADD_WORKER](state, worker) {
        state.workerList[worker.user.code] = worker;
    },
    [mutationType.CHECK_RELATED_WORKER](state, code) {
        const oldValue = state.workerList[code].relatedWeight;
        const newValue = oldValue ? oldValue + 1 : 1;
        state.workerList[code].relatedWeight = newValue;
    },
    [mutationType.DELETE_WORKER](state, workerCode) {
        delete state.workerList[workerCode];
    },
    [mutationType.DELETE_ALL_WORKER](state) {
        state.workerList = {};
    },
    [mutationType.DELAY_SHARE_ORDER]() {
        // Subscribe Mutation Only
    },
    [mutationType.ADD_ORDER](state, order) {
        state.orderList[order.orderId] = order;
    },
    [mutationType.SET_ORDER_LIST](state, payload = {}) {
        state.orderList = payload;
    },
    [mutationType.ADD_SELECTED_ORDER_ITEM_BY_ID](state, orderData) {
        state.selectedOrderItemsObj[orderData.orderId] = orderData;
    },
    [mutationType.CLEAR_SELECTED_ORDER_ITEM_BY_ID](state, orderId) {
        delete state.selectedOrderItemsObj[orderId];
    },
    /**
     * 현재 필터값 셋팅
     * @param state
     * @param filterList
     */
    [mutationType.SET_ORDER_FILTER](state, filterList) {
        state.selectedOrderFilter = filterList;
    },
    /** 주문 카운트 set */
    [mutationType.SET_STATUS_TOTAL_COUNT](state, payload) {
        state.orderTotal = {
            ...payload,
            ALL: Object.values(payload).reduce((acc, it) => acc + it, 0),
        };
    },
    /**
     * 주문 통계 업데이트
     * @param state
     * @param updateData 업데이트 객체
     */
    [mutationType.UPDATE_STATUS_ORDER](state, updateData) {
        const { orderTotal } = state;
        let count = 0;
        Object.keys(updateData).forEach((key) => {
            orderTotal[key] += updateData[key];
            count += updateData[key];
        });
        orderTotal.ALL += count;
    },
    [mutationType.UPDATE_ORDER_CARD_NAME](state, { orderId, cardName }) {
        const order = state.orderList[orderId];
        if (!order) {
            console.log(`[UPDATE_ORDER_CARD_NAME] Not Exist Order. Order Id ${orderId}`);
            return;
        }
        order.cardName = cardName;
    },
    [mutationType.UPDATE_ORDER](state, order) {
        const { orderId } = order;
        const oldOrder = state.orderList[orderId];
        oldOrder.assignOrder(order);
        state.orderList[orderId] = oldOrder;
    },
    [mutationType.DELETE_ORDER](state, orderId) {
        delete state.orderList[orderId];
    },
    [mutationType.SET_MODAL_ORDER_DATA](state, orderData) {
        state.modalOrderData = orderData;
    },
    [mutationType.SET_SELECT_FILTER](state, [selectType, value,]) {
        const mapper = {
            orderAgencyType: 'selectedOrderAgencyType',
            ownerType: 'selectedOwnerType',
            payType: 'selectedPayType',
            searchWordType: 'selectedSearchWordType',
            searchWord: 'searchWord',
        };
        state[mapper[selectType]] = value;
    },
    /** 선택한 상점 일괄 취소 */
    [mutationType.CELAR_SELECTED_ORDER_ITEMS](state) {
        state.selectedOrderItemsObj = {};
    },
    /** 일시 정지 플래그 */
    [mutationType.SET_IS_STOP](state, flag) {
        state.isStop = flag;
    },
    /** 카드 완료건 */
    [mutationType.SET_CARD_ORDER_COUNT](state, count) {
        state.cardOrderCount = count;
    },
    [mutationType.ADD_RELATED_WORKER_LIST]() {
    },
    [mutationType.CLEAR_RELATED_WORKER_LIST]() {
    },
    [mutationType.SET_WORKER_FILTER](state, filterList) {
        state.selectedWorkerFilter = filterList;
    },
    [mutationType.INPUT_SEARCH_WORKER_QUERY](state, query) {
        state.searchWorkerQuery = query;
    },
    [mutationType.SET_IS_HIDE_SHARE_WORKER]() {
    },
    [mutationType.SET_IS_HIDE_WORKER_MARKER]() { },
    [mutationType.SET_WORKER_TOTAL_COUNT](state, payload) {
        const all = Object.keys(payload).reduce((count, key) => count + payload[key], 0);
        state.workerTotal = {
            ...payload,
            all,
        };
    },
    /**
     * 워커 통계 업데이트
     * @param state
     * @param updateData
     */
    [mutationType.UPDATE_STATUS_WORKER](state, updateData) {
        let count = 0;
        Object.keys(updateData).forEach((key) => {
            if (key !== 'null') {
                state.workerTotal[key] += updateData[key];
                count += updateData[key];
            }
        });
        state.workerTotal.all += count;
    },
    [mutationType.SET_SORT_BY](state, value) {
        state.sortBy = value;
    },
    [mutationType.SET_WORKER_SORT_BY](state, value) {
        state.workerSortBy = value;
    },
};
export default mutations;
